import t from "../../../@babel/runtime/helpers/esm/extends.js";
import e from "../InputBase/inputBaseClasses.js";
import s from "../../utils/esm/generateUtilityClasses/generateUtilityClasses.js";
const r = t({}, e, s("MuiOutlinedInput", ["root", "notchedOutline", "input"]));
export {
  r as default
};
